import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Group } from '../../../dtos/group';

@Component({
  selector: 'app-group-hover-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './group-hover-popup.component.html',
  styleUrls: ['./group-hover-popup.component.scss'],
})
export class GroupHoverPopupComponent {
  @Input() group: Group | null = null;
  showPopup = false;

  constructor(private router: Router) {}

  onMouseEnter(): void {
    this.showPopup = true;
  }

  onMouseLeave(): void {
    this.showPopup = false;
  }

  onClick(): void {
    if (this.group?.id) {
      this.router.navigate(['/groups', this.group.id]);
    }
  }
}
